import { createRouter, createWebHistory } from "vue-router"
import type { Component } from "vue-utils"
import NotFound from "./NotFound"
import PWA from "./PWA"

const routes: Record<string, Component> = {
	"/": PWA,
	"/:pathMatch(.*)*": NotFound as Component,
}

const router = createRouter({
	routes: Object.entries(routes).map(([path, component]) => ({
		path,
		name: component.displayName as string,
		component,
	})),
	history: createWebHistory("/"),
})

export default router
